import { render } from "./CreateNewPassword.vue?vue&type=template&id=711bcc02&scoped=true"
import script from "./CreateNewPassword.vue?vue&type=script&lang=js"
export * from "./CreateNewPassword.vue?vue&type=script&lang=js"

import "./CreateNewPassword.vue?vue&type=style&index=0&id=711bcc02&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-711bcc02"]])

export default __exports__